/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PositiveSecurityPolicyModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import { PositiveSecurityPolicyItem } from './factories/positive-security-policy.item.factory';
import { PositiveSecurityParamsConfigItem } from './factories/positive-security-params.config-item.factory';
import { PositiveSecurityPolicyCollection } from './factories/positive-security-policy.collection.factory';

import {
    POSITIVE_SECURITY_PARAMS_CONFIG_ITEM,
    POSITIVE_SECURITY_POLICY_COLLECTION_TOKEN,
    POSITIVE_SECURITY_POLICY_ITEM_TOKEN,
} from './positive-security-policy.tokens';

const positiveSecurityPolicyModule = angular.module('avi/positive-security-policy');

const factories = [
    {
        factory: PositiveSecurityPolicyItem,
        name: POSITIVE_SECURITY_POLICY_ITEM_TOKEN,
    },
    {
        factory: PositiveSecurityParamsConfigItem,
        name: POSITIVE_SECURITY_PARAMS_CONFIG_ITEM,
    },
    {
        factory: PositiveSecurityPolicyCollection,
        name: POSITIVE_SECURITY_POLICY_COLLECTION_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(positiveSecurityPolicyModule, 'factory', name, factory);
});
